// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2xM1o","approved":"Status_approved__12lY-","rejected":"Status_rejected__2FbX5","expired":"Status_expired__3QrHN","label":"Status_label__1OC-p"};